import { BUSINESSES } from '../../constants';

// Duplicate the outdated budgets constant here, since we need to still show the
// old intended changes. None of the budget fields still exist on the campaigns.
const budgets = [
  {
    name: 'Onsite',
    key: 'budgetOnsite',
    business: BUSINESSES.MEDIA_ONSITE,
  },
  {
    name: 'Paid Social',
    key: 'budgetPaidsocial',
    business: BUSINESSES.MEDIA_OFFSITE,
  },
  {
    name: 'Display & Search',
    key: 'budgetDisplaySearch',
    business: BUSINESSES.MEDIA_OFFSITE,
  },
  {
    name: 'CI',
    key: 'budgetCi',
    business: BUSINESSES.CONSUMER_INSIGHTS,
  },
  {
    name: 'Creative',
    key: 'budgetCreative',
    business: BUSINESSES.CREATIVE,
  },
  {
    name: 'Other',
    key: 'budgetOther',
    business: BUSINESSES.OTHER,
  },
];

export default budgets;
